// src/api/apiConfig.js
const BASE_URL = process.env.REACT_APP_ENV === 'production' 
    ? process.env.REACT_APP_BACKEND_URL_PRODUCTION 
    : process.env.REACT_APP_BACKEND_URL_DEVELOPMENT;

export default BASE_URL;
